import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const serviceTypeApi = createApi({
  reducerPath: 'serviceTypeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['serviceType'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getServiceTypeList: builder.query({
      query: () => ({
        method: 'GET',
        path: `ServiceTypes`,
      }),
      providesTags: ['serviceType'],
    }),
    createNewServiceType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'ServiceTypes',
      }),
      invalidatesTags: ['serviceType'],
    }),
    updateServiceType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: `ServiceTypes`,
      }),
      invalidatesTags: ['serviceType'],
    }),
    deleteServiceType: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `ServiceTypes/${id}`,
      }),
      invalidatesTags: ['serviceType'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const serviceTypeApiReducerName = serviceTypeApi.reducerPath;
export const serviceTypeApiReducer = serviceTypeApi.reducer;
export const serviceTypeApiMiddleware = serviceTypeApi.middleware;

export const {
  useGetServiceTypeListQuery,
  useCreateNewServiceTypeMutation,
  useUpdateServiceTypeMutation,
  useDeleteServiceTypeMutation,
} = serviceTypeApi;
